import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-banner3',
  templateUrl: './top-banner3.component.html',
  styleUrls: ['./top-banner3.component.scss']
})
export class TopBanner3Component implements OnInit {

  @Input() topbanner3Type:string;

  constructor() { }

  ngOnInit(): void {
  }

}
